import React, { Component } from 'react';
import './StepConfirmation.css';
import comfortAlert from '../../img/comfortAlert.png';
import ApiConnector from '../api/ApiConnector'
import GlobalStore from "../../store/GlobalStore";
import 'react-notifications/lib/notifications.css';
import {NotificationContainer, NotificationManager} from 'react-notifications';
import ReactQueryParams from 'react-query-params';
import TagManager from 'react-gtm-module';
import { config } from '../../config.js';

class StepConfirmation extends ReactQueryParams {
    constructor(props) {
        super(props);
        this.callCreateNewBooking = this.callCreateNewBooking.bind(this);
        this.state = {
            loader: false,
            modalErrorClass: '',
            modalErrorClassSSN: ''
        };
    }

    clearCookiesAndRestart() {
        GlobalStore.getInstance().data['currentStep'] = 1;
        GlobalStore.getInstance().data['filterDoctorName'] = undefined;
        GlobalStore.getInstance().data['filterDoctorId'] = undefined;
        window.location.reload();
    }

    callCreateNewBooking() {
        this.setState({ loader: true });

        const tagManagerArgsResultConfirmPage = {
            dataLayer: {
                event: 'purchase',
                ecommerce: {
                    value: 40,
                    currency: 'USD',
                    items: [{
                        item_name: "bookd" + new Date().toString()
                        + " " + GlobalStore.getInstance().data['categoryName']
                        + ",_, " + GlobalStore.getInstance().data['stepTimeData']["activeDoctorName"]
                        + " " + GlobalStore.getInstance().data['stepTimeData']["StartTime"],
                        item_category: 'appointment booked react',
                    }]
                }
            }
        };

        console.log("config environment: " + config.environment);
        fetch(
            'https://hammasoskari.fi/wp-json/oskariapi/submit-for-nps', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    "first_name": GlobalStore.getInstance().data['userShortData']["userName"].charAt(0),
                    "phone_number": GlobalStore.getInstance().data['userShortData']["personalPhone"],
                    "date_and_time_of_the_visit": GlobalStore.getInstance().data['stepTimeData']["StartTime"],
                    "sms_status": "scheduled",
                    "doctor_name": GlobalStore.getInstance().data['stepTimeData']["activeDoctorName"]
                })
            }
        );

        if (this.queryParams.env !== "test" && config.environment === "prod") {
            console.log("booking confirmation page was achieved - analytics event sent");
            TagManager.dataLayer(tagManagerArgsResultConfirmPage);
        }

        let remindersArray = [];
        if(this.refs.hourBefore.checked) {
            remindersArray.push(0);
        }
        if(this.refs.dayBefore.checked) {
            remindersArray.push(1);
        }

        GlobalStore.getInstance().data['remindersArray'] = remindersArray;
        let createNewBooking = ApiConnector.createNewBooking();
        createNewBooking.then((response) => {
            console.log("here comes the create new booking response: ");
            console.log(response);

            if (!response.ok) {

                response.json().then(resultObject => {

                    console.log(resultObject);

                    switch (resultObject.ErrorCode) {
                        case 421: {

                            this.setState({loader: false, modalErrorClassSSN: 'errorModalIfNotValidVisible' });
                            break;

                        }
                        default: {

                            this.setState({loader: false, modalErrorClass: 'errorModalIfNotValidVisible' });
                            break;
                        }
                    }

                });

            } else {
                this.props.nextStep();
            }


            
        }).catch(() => {
            //create new booking failed
            const tagManagerArgsUniversal = {
                dataLayer: {
                    event: 'booking_failed'
                }
            };

            if (this.queryParams.env !== "test" && config.environment === "prod") {
                TagManager.dataLayer(tagManagerArgsUniversal);
            }
            this.setState({ loader: false });
            NotificationManager.warning('Pyyntö evätty internet-yhteysongelman vuoksi. Klikkaa tästä lähettääksesi pyyntö uudelleen', 'Yhteysongelma', 10000, () => {
                this.callCreateNewBooking();
            });
        });
    }

    render() {
        let stepTimeData = GlobalStore.getInstance().data['stepTimeData'];
        let activeDate = new Date(stepTimeData.StartTime);
        let currentDay = activeDate.getDate();
        let currentMonth = activeDate.getMonth() + 1;

        if(currentDay < 10){
            currentDay = '0' + currentDay;
        }
        if(currentMonth < 10){
            currentMonth = '0' + currentMonth;
        }
        activeDate = currentDay + '.' + currentMonth + '.' + activeDate.getFullYear();

        console.log("step time data from the shop: " ); console.log(stepTimeData);
        // console.log("global store at step confirmation: ");
        // console.log(GlobalStore.getInstance()._data);
        let userShortData = GlobalStore.getInstance().data['userShortData'];
        return (
            <div>
                <div className="stepConfirmationContainer col-xs-12">

                    {(this.state.loader === true) ? <div className="globalLoader loaderNotFirstStep"><div className="globalSpinner"></div></div> : ''}

                    <div className="confirmInfoBox col-xs-12">
                        <img src={comfortAlert}/>
                        <span>Ajanvarausta ei ole vielä vahvistettu.</span>
                        Tarkista ajanvarauksen tiedot ennen vahvistamista.
                    </div>
                    <div className="stepPersonalData verifyContainer">
                        <div className="stepPersonalDataTitle">Ajanvaraustiedot:</div>
                        <div className="col-xs-12 rightPadd">
                            <div><label>Valittu palvelu:</label></div>
                            <div className="resultDataBlock">{GlobalStore.getInstance().data['categoryName']}</div>
                        </div>
                        <div className="col-xs-12 leftPadd">
                            <div><label>Hoitava henkilö:</label></div>
                            <div className="resultDataBlock">{stepTimeData.activeDoctorName}</div>
                        </div>
                        <div className="col-xs-6 dataLeftPart rightPadd">
                            <div><label>Päivämäärä:</label></div>
                            <div className="resultDataBlock">
                                <div>{activeDate}</div>
                                <div><span>{stepTimeData.activeDayName}</span></div>
                            </div>
                        </div>
                        <div className="col-xs-6 rimeRightPart leftPadd">
                            <div><label>Kellonaika:</label></div>
                            <div className="resultDataBlock">
                                <div>{stepTimeData.activeFreeTime}</div>
                                <div><span>Kesto {stepTimeData.activeLength} min</span></div>
                            </div>
                        </div>
                        <div className="col-xs-6 rightPadd">
                            <div><label>Toimipiste:</label></div>
                            <div className="resultDataBlock borderNone">
                                {GlobalStore.getInstance().data['officeName']}
                                <span className="address">{GlobalStore.getInstance().data['officeAddress']}</span>
                            </div>
                        </div>
                        <div className="col-xs-6 leftPadd">
                            <div><label>Potilas:</label></div>
                            <div className="resultDataBlock borderNone">{userShortData.userName} {userShortData.userSurname}</div>
                        </div>
                    </div>

                    <div className="col-xs-12 confirmCheckboxPart">
                        <div><label className="labelOutForm">Muistutukset</label></div>
                        <div className="col-md-4 containerCheckboxContainer">
                            <label className="containerCheckbox">Muistuta minua 2 tuntia ennen
                                <input type="checkbox" ref="hourBefore" name="hourBefore" defaultChecked/>
                                <span className="checkmark"></span>
                            </label>
                        </div>
                        <div className="col-md-4 containerCheckboxContainer">
                            <label className="containerCheckbox">Muistuta minua 1 päivä ennen
                                <input type="checkbox" ref="dayBefore" name="dayBefore" defaultChecked/>
                                <span className="checkmark"></span>
                            </label>
                        </div>
                        <div className="col-md-4 nextButtonDesktop"><div className="continueButton confirmTime" onClick={this.callCreateNewBooking}>Vahvista ajanvaraus</div></div>
                    </div>

                    <div className="dataFormNavigation ssnButtonContinuePart col-xs-12">
                        <div className="col-xs-6"><div className="backButton" onClick={this.props.previousStep}>Takaisin</div></div>
                        <div className="col-xs-6"><div className="continueButton confirmTime" onClick={this.callCreateNewBooking}>Vahvista ajanvaraus</div></div>
                    </div>

                    <NotificationContainer/>

                </div>

                <div className={this.state.modalErrorClass + ' ' + 'errorModalIfNotValid animated fadeIn'}>
                    <div className="errorModalIfNotValidBody">
                        <div className="errorModalIfNotValidText">Valitsemasi aika ehdittiin juuri varata toisemme potilaalle.<br/>Käynnistä ajanvaraus uudelleen nähdäksesi vapaat ajat.</div>
                        <div className="errorModalIfNotValidButton" onClick={this.clearCookiesAndRestart}>OK</div>
                    </div>
                </div>

                <div className={this.state.modalErrorClassSSN + ' ' + 'errorModalIfNotValid errorSSN animated fadeIn'}>
                    <div className="errorModalIfNotValidBody">
                        <div className="errorModalIfNotValidText">Valitettavasti ajanvarausjärjestelmä ei tunnistanut henkilötunnustanne. Varaa aika soittamalla <a href="tel:09 566 6733">09 566 6733</a>. Voit myös lähettää tekstiviestin, niin soitamme sinulle takaisin.</div>
                        <div className="errorModalIfNotValidButton" onClick={this.props.previousStep}>Uudelleen</div>
                    </div>
                </div>

            </div>
        );
    }
}

export default StepConfirmation;



// WEBPACK FOOTER //
// ./src/components/Step_5/StepConfirmation.jsx